import React from 'react';

export const Logo = ({ className = "h-10 w-auto", showText = true }) => {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        viewBox="0 0 48 48"
        className="h-10 w-10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Foundation base */}
        <rect x="8" y="36" width="32" height="6" fill="#2563eb" rx="1" />
        
        {/* Building structure */}
        <path
          d="M12 36V18L24 10L36 18V36"
          stroke="#1e40af"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* Center pillar */}
        <rect x="22" y="18" width="4" height="18" fill="#1e40af" />
        
        {/* Left support */}
        <path
          d="M12 36L12 20L18 16"
          stroke="#3b82f6"
          strokeWidth="2"
          strokeLinecap="round"
        />
        
        {/* Right support */}
        <path
          d="M36 36L36 20L30 16"
          stroke="#3b82f6"
          strokeWidth="2"
          strokeLinecap="round"
        />
        
        {/* Roof peak */}
        <circle cx="24" cy="10" r="2.5" fill="#f97316" />
        
        {/* Accent lines */}
        <line x1="16" y1="24" x2="20" y2="24" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
        <line x1="28" y1="24" x2="32" y2="24" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
        <line x1="16" y1="30" x2="20" y2="30" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
        <line x1="28" y1="30" x2="32" y2="30" stroke="#f97316" strokeWidth="2" strokeLinecap="round" />
      </svg>
      
      {showText && (
        <div className="flex flex-col">
          <span className="text-xl font-bold text-gray-900 leading-none tracking-tight">
            Solid Base
          </span>
          <span className="text-sm font-semibold text-blue-600 leading-none tracking-wide">
            BUILDER
          </span>
        </div>
      )}
    </div>
  );
};
